import { api } from 'restaurantAdmin/api';

export interface FloorPlanTable {
  id: string;
  name: string;
  iconName: string;
  floorPlanId: string;
  floorPlanName: string;
}

export const getFloorPlanTables = async (
  restaurantId: string,
): Promise<FloorPlanTable[]> =>
  api.get(`/restaurants/${restaurantId}/floor-plan-tables`);
